import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

const SupportAndSocial = () => {
  const { siteInfo } = useSelector((state) => state.user)

  const supportAndSocialItems = siteInfo?.filter(
    (el) => el.cmsSection === 'supportAndSocial'
  )

  if (!supportAndSocialItems?.length) return null

  return (
    <ul className='m-0 list-none px-3 sm:px-0'>
      {supportAndSocialItems.map((el) => (
        <li key={el.id}>
          <NavLink to={`/site-info/${el.slug}`}>
            {el.title}
          </NavLink>
        </li>
      ))}
    </ul>
  )
}

export default React.memo(SupportAndSocial)
